import React from "react";
import { ReactComponent as DeleteIcon } from "../../../../../assets/svg/delete.svg";

const DeleteWidget = ({ onClick, deleteText }) => {
    return (
        <div className="delete-chart menu-option" onClick={onClick}>
            <span>Delete {deleteText ? "" : "Chart"}</span>
            <DeleteIcon />
        </div>
    );
};

export default DeleteWidget;
